import anime from '../libs/anime';
import hammer from '../libs/hammer';

class Module05Slider {
    constructor() {
        let cache = {};
        let initFunc = () => {
          initCache();
          registerEvents();
        }

        let initCache = () => {
            cache.slider = document.querySelectorAll('.module-05-slider');
        }

        let registerEvents = () => {
            for (let i = 0; i < cache.slider.length; i++) {
                if(cache.slider[i].querySelectorAll('.slide_img').length > 1) {
                    const sliderL = cache.slider[i].querySelector('.slider_left');
                    sliderL.addEventListener('click', function(){slideRight(this, true)});
            
                    const arrow_right = cache.slider[i].querySelector('.arrow-right');
                    const arrow_left = cache.slider[i].querySelector('.arrow-left');
                    arrow_right.addEventListener('click', function() {
                      slideRight(sliderL, false);
                    });
                    arrow_left.addEventListener('click', function() {
                      slideRight(sliderL, true);
                    });
            
                    var hammertime = new Hammer(cache.slider[i]);
                    hammertime.on('swipe', function(ev) {
                      if(ev.direction == 2) {
                        slideRight(sliderL, true);
                      }
                      if(ev.direction == 4) {
                        slideRight(sliderL, false);
                      }
                    });
                }
            }
        }

        var slideRight = function(sliderLeft, dir) {
            console.log(sliderLeft);
            var slider = sliderLeft.parentNode;
            slider.style.pointerEvents = "none";
            var i = slider.dataset.index;
            var img = slider.querySelectorAll('.slide_img');
            var txt = slider.querySelectorAll('.slide_content');
            var num = slider.querySelector('.num .txt');
            var imax = img.length;
        
            var currentImg = img[i];
            var currentTxt = txt[i];
        
            if(i < imax-1){
              i++;
              slider.dataset.index = i;
            }
            else {
              i = 0;
              slider.dataset.index = i;
            }
        
            var nxtImg = img[i];
            var nxtTxt = txt[i];
            var nxt2Img;
            var nxt3Img;
        
            if(imax > 2) {
              if(i < (imax-1)){
                nxt2Img = img[i+1];
              }
              else {
                nxt2Img = img[0];
              }
        
              if((i+1) < (imax-1)){
                nxt3Img = img[i+2];
              }
              else if((i+1) == (imax-1)){
                nxt3Img = img[0];
              }
              else {
                nxt3Img = img[1];
              }
            }
        
            else {
              if((i == 0)){
                nxt3Img = img[1];
              }
              else if(i == 1){
                nxt3Img = img[0];
              }
            }
        
        
        // Anime txt
            anime({
              targets: currentTxt,
              opacity: 0,
              translateX: ['-50%', '-40%'],
              translateY: ['-50%','-50%'],
              duration: 500,
              easing: 'easeOutSine',
            });
            anime({
              targets: nxtTxt,
              opacity: [0,1],
              translateX: ['-60%', '-50%'],
              translateY: ['-50%','-50%'],
              scale: [0.9,1],
              duration: 500,
              easing: 'easeOutSine',
            });
        
        // Anime number
        
            anime({
              targets: num,
              opacity: 0,
              translateX: -10,
              duration: 300,
              easing: 'easeOutSine',
              complete: function() {
                num.innerHTML = i+1;
                anime({
                  targets: num,
                  opacity: 1,
                  translateX: 0,
                  duration: 300,
                  easing: 'easeOutSine',
                });
              }
            });
        
        
        // Anime Img
          if(dir) {
            anime({
              targets: currentImg,
              opacity: 0,
              translateX: ['-50%', '-20%'],
              translateY: ['-50%','-50%'],
              scale: [1,0.8],
              rotate: 15,
              duration: 400,
              easing: 'easeOutSine',
              complete: function() {
                currentImg.style.zIndex=0;
                nxtImg.style.zIndex=3;
                if(imax > 2) {
                  nxt2Img.style.zIndex=2;
                }
                nxt3Img.style.zIndex=1;
                anime({
                  targets: nxt3Img,
                  translateX: ['-50%', '-50%'],
                  translateY: ['-50%','-50%'],
                  opacity: 1,
                  scale: [0.8,1],
                  rotate: [-20,-10],
                  duration: 400,
                  easing: 'easeOutSine',
                  complete: function() {
                    slider.style.pointerEvents = "all";
                  }
                });
              }
            });
          }
          else {
            anime({
              targets: currentImg,
              opacity: 0,
              translateX: ['-50%', '-70%'],
              translateY: ['-50%','-50%'],
              scale: [1,0.8],
              rotate: -15,
              duration: 400,
              easing: 'easeOutSine',
              complete: function() {
                currentImg.style.zIndex=0;
                nxtImg.style.zIndex=3;
                if(imax > 2) {
                  nxt2Img.style.zIndex=2;
                }
                nxt3Img.style.zIndex=1;
                anime({
                  targets: nxt3Img,
                  translateX: ['-50%', '-50%'],
                  translateY: ['-50%','-50%'],
                  opacity: 1,
                  scale: [0.8,1],
                  rotate: [-20,-10],
                  duration: 400,
                  easing: 'easeOutSine',
                  complete: function() {
                    slider.style.pointerEvents = "all";
                  }
                });
              }
            });
          }
        
              anime({
                targets: nxtImg,
                translateX: ['-50%', '-50%'],
                translateY: ['-50%','-50%'],
                rotate: [10,0],
                delay: 100,
                duration: 400,
                easing: 'easeOutSine',
              });
        
              if(imax > 2) {
                anime({
                  targets: nxt2Img,
                  translateX: ['-50%', '-50%'],
                  translateY: ['-50%','-50%'],
                  rotate: [-10,10],
                  delay:100,
                  duration: 400,
                  easing: 'easeOutSine',
                });
              }
          }

        initFunc();
    }
}
export { Module05Slider }
